import React, { Component } from 'react';
import PropTypes from 'prop-types';


//import {white} from '@mui/material/colors';
import { alpha } from '@mui/system/colorManipulator';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, MenuItem, Select, TextField, type Theme } from '@mui/material';
import {bizpost} from '../../ajax';
import { SubmitButton } from '../dialogs';

/////////////
//import { styled, alpha } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
// import AppBar from '@mui/material/AppBar';
// import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
//import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
// import MenuIcon from '@mui/icons-material/Menu';
//import SearchIcon from '@mui/icons-material/Search';

//const SearchBox = () => {

const s:any = {
  iconButton: {
    float: 'right',
    paddingTop: 17,
    
  },
  textField: {
    color: 'white',
    backgroundColor: 'white',
    borderRadius: 2,
    height: 35
  },
  inputStyle: {
    color: 'white',
    paddingLeft: 5
  },
  hintStyle: {
    height: 16,
    paddingLeft: 5,
    color: 'white'
  },

  wrapper: (theme:Theme)=>({
    fontFamily: 'typography.fontFamily',
    position: 'relative',
    marginleft: 16,
    borderRadius: 2,
    background: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      background: alpha(theme.palette.common.white, 0.25),
    },
    '& $input': {
      transition: theme.transitions.create('width'),
      width: 400,
      '&:focus': {
        width: 550,
      },
    },
  }),
  search: {
    width: 'spacing(9)',
    height: '100%',
    position: 'absolute',
    right: 0,
    top: 0,
    pointerEvents: 'none',
    display: 'flex',
    color: 'common.white',
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {
    font: 'inherit',
    p: '1, 1, 1, 1',
    border: 0,
    display: 'block',
    //float: 'right',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    margin: 0, // Reset for Safari
    color: 'white',
    width: '100%',
    '&:focus': {
      outline: 0,
    },
  },

};

////////////////////////////////////////

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

////////////

class SearchBox extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    //this.setContent = this.setContent.bind(this);
    this.state = {
      module: 'register',
      active: false,
      loading: false,
      query: null,
    };
  }

  // menuname=(menu)=>{
  //   return menu.replace('/','');
  // }

  // handleClick = (menu,page,index)=> () => {
  //   console.log('handleclick:',menu,page,index);
  //   this.props.handleSetContent(null,page);
  // }



  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  onSearch = async (evennt:any) => {
    try{
      const {onSearched} = this.props;
      const {query} = this.state;
      console.log('starting onSearch.submit... ');
      try{
        let params = {s:'searchboard',a:'find',qry:query};
        console.log('service request ',params);
        this.startLoading();
        var response = await bizpost(params);
        //console.log('service response ',response); 
  
        if (response.success){
          //this.props.showNotification(response.sm,'success',response.st);
          //onResponse(true,response);

          const {sd:results=[],md:meta=[]} = response;
          const len = results.length;
          if(len>0){
            console.log('search this: ',this); 
            this.setState({results});
            if(typeof onSearched === 'function'){
              onSearched(query,results,meta); 
            }
          }
        }
        else {
          this.props.showNotification(response.message,response.type||'error',response.title);
        }   
      }
      catch(err){
        console.log('search.submit.err',err);
      }
      
    }
    catch(err){
      //
      console.log('search.err',err);
    }
    finally{
      this.stopLoading();
    }
  }

  onSelect = (event:any) => {
    this.setState({module:event.target.value});
  }

  onFocus = (event:any) => {
    this.setState({active:true});
  }

  onKeyUp = (event:any) => {
    if(event.key === 'Enter') this.onSearch(event.target.value);
  }

  onChange = (event:any) => {
    const value = event.target.value;
    this.setState({query:value});
  }

  renderSearch(){
    return (
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search…"
          inputProps={{ 'aria-label': 'search' }}
        />
      </Search>
    );
  }

  render(){
    //const { navDrawerOpen, handleSetContent, closeDrawer, openDrawer, toggleDrawer, classes, theme } = this.props;
    const { onKeyPress, classes } = this.props;
    const {module,active,loading} = this.state;

    const xid = 'sbox';

    return (
      // <Box>
      //   <TextField
      //     //helperText="Search..."
      //     // underlineShow={false}
      //     fullWidth={true}
      //     //InputProps={{style:{classes.textField}}}
      //     sx={{...s.textField}}
      //     //InputProps={{className:classes.textField}}
      //     //inputStyle={classes.inputStyle}
      //     //hintStyle={classes.hintStyle}
      //     FormHelperTextProps={{className:classes.hintStyle}}
      //   />
      //   <IconButton color="contrast" sx={{...s.iconButton}} >
      //     <SearchIcon />
      //   </IconButton>
      // </Box>

      // // option 2
      // <Box sx={{...s.wrapper}}>
      //   <input id="docsearch-input" sx={{...s.input}} onKeyPress={this.onKeyPress}/>
      //   <Box sx={{...s.search}}>
      //     <IconButton>
      //     <SearchIcon />
      //     </IconButton>
      //   </Box>
      // </Box>

      // option 3
      <TextField
        //label={label}
        id={xid}
        //name={id}
        type={'text'}
        //required={required}
        margin='dense'
        fullWidth={true}
        //sx={{...s.textField}}      
        sx={{...s.textField,width:400, backgroundColor:'transparent', '& .MuiInputBase-input': { // Target the input element
          color: 'white',
        }, marginTop:0, height:40,'& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },}}      
        //value={value}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Select
                value={module}
                onChange={this.onSelect}
                disableUnderline // Optional: Removes the default underline from the Select
                variant="standard" // Or 'filled', depending on your TextField variant
                sx={{color:'white','& .MuiSvgIcon-root': {
            color: 'white', // For the dropdown arrow icon
          },}}
              >
                <MenuItem value="register">main</MenuItem>
                <MenuItem value="inspection">monitoring</MenuItem>
                <MenuItem value="system">system</MenuItem>
              </Select>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" sx={{ 
              marginRight: 0, // Remove default right margin
              alignItems: 'right !important',
              // You can add other styles here if needed, e.g., paddingLeft: 0
            }}>
              {/* <label htmlFor={xid}> */}
              
              <SubmitButton 
                //color={'white'}
                sx={{color:'white'}}
                onClick={this.onSearch}
                //onMouseDown={this.onMouseDown}
                loading={loading}
              >
                <SearchIcon color={'inherit'}/>
                {/* <input
                  style={{opacity:0,width:1}}
                  accept={xaccept}
                  id={xid}
                  name={xname}
                  type="file"
                  onChange={this.onChange}
                /> */}
              </SubmitButton>
              
              {/* preview&& */}
              {/* {<img className={(preview&&source)?classes.preview:classes.hidden} style={previewStyle||{}} src={source} alt=""/>} */}
              {/* </label> */}
            </InputAdornment>
          ),
          //readOnly: true,
        }}
        //onKeyDown={this.disableEvent}
        onKeyUp={this.onKeyUp}
        //{...ooptions}
        onChange={this.onChange}
      />
  );
    //);
  }
};

export default SearchBox;



SearchBox.propTypes = {
  classes: PropTypes.object.isRequired,
};
